import React, { useState, useRef, useEffect } from "react"
import { Upload, X, Check, AlertCircle, Loader2, Trash2, Save, AlertTriangle } from "lucide-react"
import { Button, Badge, Input, message, useCRUDController, Row, Col, Select, Typography, Tabs, Spin } from "../../ui/ot"
import StatsCard from "../../ui/stats-card"
import { LineBasicChart } from "../../charts/views/line_basic_chart"
import dayjs from 'dayjs';

const colors = ["#fb7d89", "#bad1c9", "#85b873", "#e5db9e", "#f3a46c", "#f6bb5d", "#55abb8", "#001219", "#005f73", "#0a9396", "#94d2bd", "#e9d8a6", "#ee9b00", "#ca6702", "#bb3e03", "#ae2012", "#9b2226", "#f94144", "#f3722c", "#f8961e", "#f9844a", "#f9c74f", "#90be6d", "#43aa8b", "#4d908e", "#577590", "#277da1"]
const basicFilterSetting = ["branchcode", "time","time_type"]
const ChartTimeSlotCirculationDistribution = ({
    filterSearchParams = [...basicFilterSetting],
    propsDataParams = null,
}) => {
    const [data, setData] = useState([
    ])
    const [chartConfig, setChartConfig] = useState({
        visitors: {
            label: "Visitors",
        }
    })
    const [loading, setLoading] = useState(false)

    const [searchParams, setSearchParams] = useState({
        branchcode: null,
        start_time: filterSearchParams.includes("time") ? dayjs().startOf('year').subtract(5,"year").format('YYYY-MM-DD') : null,
        end_time: filterSearchParams.includes("time") ? dayjs().endOf('year').format('YYYY-MM-DD') : null,
        time_type: "year",
        ...propsDataParams
    })
    const getData = () => {
        setLoading(true)
        dataController.getData({
            ...searchParams
        }).then((response) => {
            setLoading(false)
            if (response) {
                let newData = Object.values(response)
                const labelSet = {
                    checkout_data:"借閱數量",
                    return_data:"歸還數量",
                }
                setChartConfig((pre) => {
                    const config = {}; // 建立一個空物件
                    let firstData = newData?.find((e) => true)
                    Object.keys(firstData).forEach((key, index) => {
                        if (key !== 'hour_label') {
                            config[key] = {
                                label: labelSet[key],
                                color: colors[index % colors.length],
                            };
                        }
                    });
                    return config;
                })
                setData(newData)
            }
        })
    }
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const dataController = useCRUDController({ apiRoute: "/koha/report/circulation/period_distribution" })
    useEffect(() => {
        getData()
    }, [searchParams])
    useEffect(() => {
        libraryController.getData({})
    }, [])

    return (<Row>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                {filterSearchParams.includes("branchcode") ? <Col>
                    <Row align={"middle"} gutter={[8, 8]}>
                        <Col>
                            分館篩選：
                        </Col>
                        <Col>
                            <Select
                                allowClear={true}
                                defaultValue={searchParams?.branchcode}
                                value={searchParams?.branchcode}
                                onChange={(value) => {
                                    setSearchParams((pre) => {
                                        return {
                                            ...pre,
                                            branchcode: value
                                        }
                                    })
                                }}
                                options={libraryController?.ResponseData?.map((option) => {
                                    return {
                                        label: `(${option?.branchcode})${option?.branchname}`,
                                        value: option?.branchcode,
                                    }
                                })}
                            >
                            </Select>
                        </Col>
                    </Row>
                </Col> : <></>}
                
            </Row>
        </Col>
        <Col span={24} >
            {
                loading ?
                    <Row justify="center">
                        <Col>
                            <Spin />
                        </Col>
                    </Row>
                    :
                    <LineBasicChart
                        //key 的 標籤及顯示顏色設定
                        chartConfig={chartConfig}
                        //data
                        chartData={data}
                        //X 軸顯示的名稱得key
                        xDataKeyArr={["hour_label"]}
                        //Y 軸顯示的名稱得key
                        yDataKeyArr={Object.keys(chartConfig)} //幾條線
                        //在線上顯示數值
                        showLabel={true} //true false
                        //在線上標出點
                        showDot={true} //true false
                        //線的種類
                        lineType="linear" // "natural" 、"linear"、 "step"
                    />
            }

        </Col>
    </Row>)
}
export { ChartTimeSlotCirculationDistribution }